class Underlay {
  // Create element
  init() {
    [this.body] = document.getElementsByTagName('BODY');
    this.element = document.createElement('div');
    this.element.classList.add('transparent-underlay');
  }

  // Show element
  // If element not exist, create element
  show(zindex = 11) {
    if (!this.element) {
      this.init();
    }

    this.element.style.zIndex = zindex;
    this.body.appendChild(this.element);
  }

  // hide element
  hide() {
    if (this.element) {
      this.element.remove();
    }
  }
}

/* eslint-disable no-class-assign */
export default Underlay = new Underlay();
/* eslint-enable no-class-assign */
